import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import EmailOtpForm from '@/components/EmailOtpForm';
import PinLoginForm from '@/components/PinLoginForm';

const GOOGLE_AUTH_URL = 'https://auth.emergentagent.com/';

export default function StudentAuth() {
  const navigate = useNavigate();
  const [mode, setMode] = useState('otp');

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Trailing slash is REQUIRED — iOS Safari strips hash fragments from URLs without it (WebKit bug #24701)
    const redirectUrl = window.location.origin + '/auth/callback/student/';
    window.location.href = `${GOOGLE_AUTH_URL}?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="adult-layout min-h-screen bg-gradient-to-b from-purple-50 to-white flex items-center justify-center px-4 py-10">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <button
          data-testid="student-auth-back-to-home"
          onClick={() => navigate('/')}
          className="text-sm text-gray-500 hover:text-gray-700 mb-6"
        >
          ← Back to home
        </button>
        <div className="bg-white rounded-3xl shadow-lg p-8 border border-purple-100">
          <h1 className="text-2xl font-bold text-gray-900 mb-1">Hi Student!</h1>
          <p className="text-sm text-gray-500 mb-6">
            Sign in to start your learning journey.
          </p>

          <button
            data-testid="student-auth-google-button"
            onClick={handleGoogle}
            className="w-full flex items-center justify-center gap-3 border border-gray-200 hover:border-gray-300 bg-white text-gray-800 py-3 rounded-xl font-medium transition mb-4"
          >
            <GoogleIcon /> Continue with Google
          </button>

          <Divider />

          {/* --- Email + PIN tab temporarily hidden (restore by un-commenting) ---
          <div className="flex gap-2 mb-5">
            <TabButton active={mode === 'otp'} onClick={() => setMode('otp')} testId="student-auth-tab-otp">
              Email code
            </TabButton>
            <TabButton active={mode === 'pin'} onClick={() => setMode('pin')} testId="student-auth-tab-pin">
              Email + PIN
            </TabButton>
          </div>

          {mode === 'otp' ? (
            <EmailOtpForm roleHint="student" accentClass="bg-purple-600 hover:bg-purple-700" />
          ) : (
            <PinLoginForm accentClass="bg-purple-600 hover:bg-purple-700" />
          )}
          --- end of hidden block --- */}

          <EmailOtpForm roleHint="student" accentClass="bg-purple-600 hover:bg-purple-700" />
        </div>
      </motion.div>
    </div>
  );
}

function Divider() {
  return (
    <div className="flex items-center gap-3 my-5">
      <div className="h-px bg-gray-200 flex-1" />
      <span className="text-xs text-gray-400 uppercase tracking-wider">or</span>
      <div className="h-px bg-gray-200 flex-1" />
    </div>
  );
}

function TabButton({ active, onClick, children, testId }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={`flex-1 py-2 text-sm rounded-lg font-medium transition ${
        active
          ? 'bg-purple-100 text-purple-700'
          : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
      }`}
    >
      {children}
    </button>
  );
}

function GoogleIcon() {
  return (
    <svg className="w-5 h-5" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" />
      <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z" />
      <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z" />
      <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571.001-.001.002-.001.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z" />
    </svg>
  );
}
